import styled from 'styled-components';
import { useState, useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';


export default function SettingsIndex (props:Props) {
    
    return(
        <Outlet/>
    )
}

interface Props {
    
}